export default __webpack_public_path__ + "static/media/photo-5.d7e580c1.jpg";